// CSS Modules - component class name prefix: BlueTextTeaser__

<template>
  <div :class="$style.container">
    <a :href="linkUrl" :target="newWindow ? '_blank' : '_self'">
      <div class="columns is-mobile">
        <div v-if="icon || title" :class="[$style.icon, 'column']">
          <i v-if="icon" :class="icon"></i>
          <h4 :class="[icon ? $style.headWithIcon : null]" v-if="title">
            {{ title }}
          </h4>
        </div>
      </div>
      <p v-if="copy">{{ copy }}</p>
    </a>
  </div>
</template>

<script>
export default {
  name: "BlueTextTeaser",
  props: {
    icon: {
      type: String
    },
    title: {
      type: String,
      default: ""
    },
    copy: {
      type: String,
      required: false,
      default: ""
    },
    linkUrl: {
      type: String
    },
    newWindow: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style module lang="scss">
@import "./BlueTextTeaser.scss";
</style>
